<script>
import Sidebar from '../../components/Sidebar.vue'
import Topbar from '../../components/Topbar.vue'
import { mapState } from 'vuex'

export default {
  name: 'Home',
  components: {
    Sidebar,
    Topbar
  },
  methods: {
    clearElement (param) {
      this.model[param] = null
    }
  },
  created () {
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('auth', ['user'])
  }
}
</script>

<template>
  <div class="home">
    <Topbar />
    <div id="wrapper">
      <Sidebar />
      <div id="content-wrapper">
        <div class="wellcome">
          <p>Seja bem vindo {{user.user.nome}}</p>
        </div>
      </div>
    </div>

    <a class="scroll-to-top rounded" href="#page-top">
      <i class="fas fa-angle-up"></i>
    </a>
  </div>
</template>

<style scoped>
  .wellcome{margin-left: 20px}
  .wellcome p {color: rgb(141, 154, 177); font-size: 1.3em}
</style>
